export const languagesMap: Record<string, string> = {
  EN: 'English',
  ZH_CN: '简体中文',
  ZH_HK: '繁体中文',
  AR: 'العربية',
  BN: 'বাংলা',
  FIL: 'Filipino',
  FR: 'Français',
  DE: 'Deutsch',
  HI_IN: 'हिन्दी',
  IT: 'Italiano',
  JA: '日本語',
  KO: '한국어',
  MN_MN: 'Монгол',
  PT: 'Português',
  RU: 'Русский',
  ES: 'Español',
  TH: 'ภาษาไทย',
  UK: 'Українська',
  VI: 'Tiếng Việt',
};
